var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChartBar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5956_45579)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.27273 0.636364C1.27273 0.28491 0.987818 0 0.636364 0C0.28491 0 0 0.28491 0 0.636364V13.3636C0 13.7151 0.28491 14 0.636364 14H13.3636C13.7151 14 14 13.7151 14 13.3636C14 13.0122 13.7151 12.7273 13.3636 12.7273H1.27273V0.636364ZM3.60606 6.36364C3.95751 6.36364 4.24242 6.64855 4.24242 7V10.3939C4.24242 10.7454 3.95751 11.0303 3.60606 11.0303C3.25461 11.0303 2.9697 10.7454 2.9697 10.3939V7C2.9697 6.64855 3.25461 6.36364 3.60606 6.36364ZM7.21212 3.60606C7.21212 3.25461 6.92721 2.9697 6.57576 2.9697C6.2243 2.9697 5.93939 3.25461 5.93939 3.60606V10.3939C5.93939 10.7454 6.2243 11.0303 6.57576 11.0303C6.92721 11.0303 7.21212 10.7454 7.21212 10.3939V3.60606ZM9.54545 6.36364C9.89691 6.36364 10.1818 6.64855 10.1818 7V10.3939C10.1818 10.7454 9.89691 11.0303 9.54545 11.0303C9.194 11.0303 8.90909 10.7454 8.90909 10.3939V7C8.90909 6.64855 9.194 6.36364 9.54545 6.36364ZM13.1515 3.60606C13.1515 3.25461 12.8666 2.9697 12.5152 2.9697C12.1637 2.9697 11.8788 3.25461 11.8788 3.60606V10.3939C11.8788 10.7454 12.1637 11.0303 12.5152 11.0303C12.8666 11.0303 13.1515 10.7454 13.1515 10.3939V3.60606Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5956_45579"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChartBar);
export default __webpack_public_path__ + "static/media/chart-bar.9bc219fd720e66cb628e232ba6ae94bc.svg";
export { ForwardRef as ReactComponent };